<script setup>
import axios from 'axios';
import { BAccordion, BAccordionItem } from 'bootstrap-vue-next';
import { onMounted, ref, computed } from 'vue';

import ContributorsTable from '~/common/components/ContributorsTable.vue';
import ThemedOverlay from '~/common/components/ThemedOverlay.vue';
import { toYMD } from '~/common/DateUtils';

import LeaderboardSummary from './LeaderboardSummary.vue';

const records = ref([]);
const busy = ref(true);
const totals = ref({});
const props = defineProps({
  currentHackathon: {
    type: Object,
    required: true,
  },
});

const filterData = computed(() => ({
  fromDate: toYMD(props.currentHackathon?.startDate),
  toDate: toYMD(props.currentHackathon?.endDate),
  mergeDate: props.currentHackathon?.mergeDate,
}));

const fetchData = async () => {
  busy.value = true;
  const response = await axios.get(
    '/api/v1/hackathons',
  );
  records.value = response.data;
  if (response.data.length > 0) {
    const firstElement = response?.data[0];
    Object.keys(firstElement).forEach((key) => {
      if (typeof firstElement[key] === 'number') {
        totals.value[key] = 0;
      }
    });
  }

  records.value.forEach((contributor) => {
    Object.keys(totals.value).forEach((contributionType) => {
      totals.value[contributionType] += contributor[contributionType] || 0;
    });
  });

  busy.value = false;
};

onMounted(() => {
  fetchData();
});
</script>

<template>
  <BAccordion class="accordion-table mb-2">
    <BAccordionItem
      title="Leaderboard"
      :visible="true"
    >
      <h2 class="p-3">{{ currentHackathon.displayName }} Hackathon</h2>
      <LeaderboardSummary
        :totals="totals"
        :contributors="records"
        :merge-date="currentHackathon.mergeDate"
      />
      <ThemedOverlay
        :show="busy"
      >
        <ContributorsTable
          :contributors="records"
          :filter-data="filterData"
          :hackathon="true"
          :totals="totals"
          sticky-header
        />
      </ThemedOverlay>
    </BAccordionItem>
  </BAccordion>
</template>
